module.exports = __webpack_public_path__ + "img/uploadfile.771fe74a.jpg";